import React from "react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Button } from "../ui/Button";
import { Separator } from "../ui/Separator";

interface AddElementSeparatorProps {
  showAddMenu: boolean;
  onShowAddMenu: (show: boolean) => void;
  onAddText: () => void;
  onAddImage: () => void;
}

export const AddElementSeparator = ({
  showAddMenu,
  onShowAddMenu,
  onAddText,
  onAddImage,
}: AddElementSeparatorProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.composeMessage",
  });

  return (
    <div
      data-testid="add-element-separator"
      className="mt-4 flex items-start gap-1.5"
    >
      <div className="flex-shrink-0">
        <div className="h-10 w-10"></div>
      </div>

      <div className="w-80">
        <div className="flex items-center">
          <Separator className="flex-1" />
          <div
            className="relative mx-4"
            onMouseEnter={() => onShowAddMenu(true)}
            onMouseLeave={() => onShowAddMenu(false)}
          >
            <div className="absolute -top-6 -right-6 -left-6 z-10 h-16" />

            <Button
              variant="ghost"
              size="sm"
              type="button"
              onClick={() => onShowAddMenu(!showAddMenu)}
              className="relative z-20 h-8 w-8 p-0"
            >
              <Plus size={16} />
            </Button>

            {showAddMenu && (
              <div className="absolute bottom-10 left-1/2 z-30 min-w-[120px] -translate-x-1/2 transform rounded-lg border bg-white py-2 shadow-lg">
                <Button
                  variant="ghost"
                  size="sm"
                  type="button"
                  onClick={onAddText}
                  className="w-full justify-start px-4 py-2 text-sm"
                >
                  {t("addText")}
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  type="button"
                  onClick={onAddImage}
                  className="w-full justify-start px-4 py-2 text-sm"
                >
                  {t("addImage")}
                </Button>
              </div>
            )}
          </div>
          <Separator className="flex-1" />
        </div>
      </div>

      <div className="flex flex-shrink-0 items-center self-center">
        <div className="h-6 w-6"></div>
      </div>
    </div>
  );
};
